import { render, staticRenderFns } from "./AssetSummary.vue?vue&type=template&id=28ed6d75&scoped=true&"
import script from "./AssetSummary.vue?vue&type=script&lang=ts&"
export * from "./AssetSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AssetSummary.vue?vue&type=style&index=0&id=28ed6d75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed6d75",
  null
  
)

export default component.exports